import React from "react";

function arrowLeftSVG() {
  return (
    <svg
      width="24"
      height="32"
      viewBox="0 0 24 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_1330_320" fill="white">
        <path d="M0 0H24V32H6C2.68629 32 0 29.3137 0 26V0Z" />
      </mask>
      <path d="M0 0H24V32H6C2.68629 32 0 29.3137 0 26V0Z" fill="#22FF91" />
      <path
        d="M0 0H24H0ZM24 33H6C2.13401 33 -1 29.866 -1 26H1C1 28.7614 3.23858 31 6 31H24V33ZM6 33C2.13401 33 -1 29.866 -1 26V0H1V26C1 28.7614 3.23858 31 6 31V33ZM24 0V32V0Z"
        fill="#E3E3E3"
        mask="url(#path-1-inside-1_1330_320)"
      />
      <path
        d="M16.5 9.08947C15.6047 8.01459 13.9459 8.03993 13.0839 9.14166L8.5 15L13.0839 20.8583C13.9459 21.9601 15.6047 21.9854 16.5 20.9105V20.9105L12.18 15L16.5 9.08947Z"
        fill="#232323"
      />
    </svg>
  );
}

export default arrowLeftSVG;
